export default __webpack_public_path__ + "static/media/SearchLensSad.2a44b470.svg";